import * as React from 'react';
import './ScrollIndicator.scss';

export const ScrollIndicator = () => {
	const [scroll, setScroll] = React.useState(0);

	const onScroll = () => {
		const scrollTop = document.documentElement.scrollTop; // property gets or sets the number of pixels that an element's content is scrolled vertically
		const height =
			document.documentElement.scrollHeight - // read-only property is a measurement of the height of an element's content, including content not visible on the screen due to overflow
			document.documentElement.clientHeight; // read-only property is zero for elements with no CSS or inline layout boxes; otherwise, it's the inner height of an element in pixels. It includes padding but excludes borders, margins, and horizontal scrollbars (if present)

		const scrolled = (scrollTop / height) * 100;
		setScroll(scrolled);
	};

	React.useEffect(() => {
		window.addEventListener('scroll', onScroll);

		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	return (
		<div className="scrollIndicator">
			<div className="progress" style={{ width: `${scroll}%` }} />
		</div>
	);
};
